import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class VisitorsSettingsIntegrationsIndexRoute extends Route {
  @service router;

  redirect() {
    this.router.transitionTo('integrations');
  }
}
